module.exports = __webpack_public_path__ + "img/04.81f4c92c.png";